import { raiseToast } from '@fiverr-private/toast';
import { appTranslate } from './utils/i18n';

export const raiseGeneralErrorToast = () => {
    raiseToast({
        type: 'error',
        location: 'top',
        message: appTranslate('toast.general_error_message'),
    });
};
